import { create } from 'zustand'

/**
 * Controls the global account / settings modal. Mirrors the feedback store so
 * any header (desktop sidebar, mobile top bar, PWA top bar) can open the same
 * account surface without prop-drilling. The modal is rendered once globally.
 */
interface AccountModalStore {
  isOpen: boolean
  open: () => void
  close: () => void
}

export const useAccountModalStore = create<AccountModalStore>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}))
